// @flow
export const primary = '#0B8457'


// Below are styles for the new websites
export const black = '#021647'
export const white = '#fff'
export const offWhite = '#F8F4EF'
export const beige = '#F7EDE3'
export const green = '#5F9267'
export const blue = '#2E65DC';
export const darkBlue = '#121C37'

export const base = black
export const siteBackground = beige
export const linkPrimary = green
export const buttonBackground = green
export const buttonLink = beige
export const footerBackground = darkBlue
export const footerBase = beige
export const footerLink = beige


// WEBPACK FOOTER //
// ./src/theme/colors.js